<script>
  import { coffre } from "../../store/OpvcmStore";
  import { tabCouleurCardInfo } from "../conf";
  import CardInfo from "../../components/ihm/CardInfo.svelte";
  import { onMount } from "svelte";
  import {blur} from 'svelte/transition'

  let listeData = [{}];
  let cumulOpvcm = 0;

  /**
   * permet de selection les opvcm dans la liste complete
   * @param data
   */
  const listOpvcm = (letype, data) => {
    let result = [];
    if ($coffre != undefined) {
      if (letype != "") {
        result = data.filter((el) => {
          return el.OP_TYPE_PLCMT == letype;
        });
      } else {
        result = $coffre;
      }

      //console.log("listOPvcm => ");
      //console.log(result);
    }
    return result;
  };

  /**
   *
   * @param letype
   */
  const choixColor = (letype) => {
    //"blue - green - orange - cherry - red"
    let colorByType = ["AUTRE", "ACT", "ASSV", "ASSV0", "PEA"];
    const index = colorByType.indexOf(letype);

    if (index <= tabCouleurCardInfo.length - 1) {
      //console.log("color:" + tabCouleurCardInfo[index] + " ind: " + index);
      return tabCouleurCardInfo[index];
    } else {
      return "green";
    }
  };

  /**
   *
   * @param letype
   * @param data
   */
  const chercher = (letype, data) => {
    cumulOpvcm = 0;
    listeData = listOpvcm(letype, data);
  };

  /***
   * calcul cul montnat vte
   */
  const cumumMTVte = (montant) => {
    cumulOpvcm += parseFloat(montant);
    return "";
  };

  /**
   *
   */
  onMount(() => {
    chercher("ASSV0", $coffre);
  });
</script>

<div class="container" transition:blur="{{amount:10}}">
  <div class="row" >
    <div class="btn-group" role="group" aria-label="Basic example">
      <button
        on:click={chercher("", $coffre)}
        type="button"
        class="btn btn-primary btn-group-sm">All</button
      >
      <button
        on:click={chercher("ASSV", $coffre)}
        type="button"
        class="btn btn-primary btn-group-sm">Assv</button
      >
      <button
        on:click={chercher("ASSV0", $coffre)}
        type="button"
        class="btn btn-primary btn-group-sm">Assv-0</button
      >
      <button
        on:click={chercher("ACT", $coffre)}
        type="button"
        class="btn btn-primary btn-group-sm">act.</button
      >
      <button
        on:click={chercher("PEA", $coffre)}
        type="button"
        class="btn btn-primary btn-group-sm">PEA</button
      >
    </div>

    {#each listeData as op}
      {cumumMTVte(op.OP_MT_VTE)}
      <div class="card col-12">
        <CardInfo
          cardTitle="{op.OP_BQ} - {new Intl.NumberFormat('fr-FR').format(
            op.OP_MT_VTE
          )} €"
          cardSubTitle1={op.OP_NOM}
          cardSubTitle2="achat : {new Intl.NumberFormat('fr-FR').format(
            op.OP_MT_ACHAT
          )} €"
          cardSubTitle3="{new Intl.NumberFormat('fr-FR').format(
            op.OP_MT_VTE - op.OP_MT_ACHAT
          )} €"
          cardColor={choixColor(op.OP_TYPE_PLCMT)}
          cardFooter="{op.OP_BENEF} - {op.OP_TYPE_PLCMT}"
        />
      </div>
    {/each}
    <div class="alert alert-success" role="alert">
      Total de la sélection = {new Intl.NumberFormat("fr-FR").format(
        cumulOpvcm
      )}
    </div>

  </div>
</div>
